export const myNftsLightTheme = {
  '--my-nfts-bgc-1': '#f8f8f8',
  '--my-nfts-bgc-2': '#fff',
  '--my-nfts-bgc-3': 'linear-gradient(120deg, #37defd 13%, #0989e5 84%)',
  '--my-nfts-bgc-4': '#9fa7b3',
  '--my-nfts-bgc-5': '#fff',
  '--my-nfts-bgc-6': 'linear-gradient(135deg, #37defd, #0989e5)',
  '--my-nfts-bgc-7': '#f8f8f8',
  '--my-nfts-font-c-1': '#333',
  '--my-nfts-font-c-2': '#666',
  '--my-nfts-font-c-3': '#65d5ff',
  '--my-nfts-font-c-4': '#fff',
  '--my-nfts-font-c-5': '#666',
  '--my-nfts-font-c-6': '#999',
  '--my-nfts-border-c-1': '#eee',
  '--my-nfts-border-c-2': '#eee',
  '--my-nfts-border-c-3': '#fff',
}
export const myNftsDarkTheme = {
  '--my-nfts-bgc-1': '#23262f',
  '--my-nfts-bgc-2': '#141417',
  '--my-nfts-bgc-3': 'linear-gradient(120deg, #37defd 13%, #0989e5 84%)',
  '--my-nfts-bgc-4': 'rgba(255, 255, 255, 0.75)',
  '--my-nfts-bgc-5': '#172130',
  '--my-nfts-bgc-6': 'linear-gradient(135deg, #37defd, #0989e5)',
  '--my-nfts-bgc-7': '#222e3d',
  '--my-nfts-font-c-1': '#fff',
  '--my-nfts-font-c-2': '#9fa7b3',
  '--my-nfts-font-c-3': '#65d5ff',
  '--my-nfts-font-c-4': '#fff',
  '--my-nfts-font-c-5': '#fff',
  '--my-nfts-font-c-6': '#fff',
  '--my-nfts-border-c-1': '#23262f',
  '--my-nfts-border-c-2': '#222e3d',
  '--my-nfts-border-c-3': 'rgba(255, 255, 255, 0.3)',
}
